import { Component, computed, input } from '@angular/core';

@Component({
  selector: 'survey-header',
  templateUrl: './survey-header.component.html',
  styleUrls: ['./survey-header.component.scss']
})
export class SurveyHeaderComponent {
  headerElement: any;
  surveyMainContainer: any
  isHeaderSticky: boolean = false

  activeContainerClassesInput = input('',{alias: 'activeContainerClasses'})

  activeContainerClasses = computed(() => {
    return 'right-0 left-0 !w-full rounded-none customHShadow px-20 bg-white ' + this.activeContainerClassesInput()
  })

  ngAfterViewInit(): void {
    this.headerElement = document.querySelector('header > div')
    this.headerElement.style.position = 'relative'
    this.headerElement.style.width = '100%'
    this.surveyMainContainer = document.querySelector('survey-main-container')
    this.surveyMainContainer.style.top = '-4rem'
  }

  ngOnDestroy(): void {
    this.headerElement.style.position = 'fixed'
    this.surveyMainContainer.style.top = '0'
    this.headerElement.style.width = '100vw'
  }

  onHeaderStickyChange(event: boolean) {
    this.isHeaderSticky = event
    const surveySidebar: any = document.querySelector('survey-sidebar')

    if (surveySidebar) {
      if (event) {
        surveySidebar.style.height = 'calc(100vh - 9.5rem)'
        surveySidebar.style.top = '6.5rem'
        surveySidebar.style.position = 'fixed'
      }
      else {
        const topDistance = 16 * 6.5;
        const sidebarTopDistance = surveySidebar.getBoundingClientRect().top;

        if (sidebarTopDistance > topDistance) {
          surveySidebar.style.height = `calc(100vh - ${sidebarTopDistance + (16 * 3)}px)`
        }
        surveySidebar.style.top = '0'
        surveySidebar.style.position = 'absolute'
      }
    }
  }

}
